import React from 'react';
import { useReveal } from '../lib/useReveal';
const BONUSES = [{
  num: '01',
  title: 'Reiki en 7 Días',
  subtitle: 'Mini guía de activación rápida',
  desc: 'Tu guía de inicio rápido. Primera semana completamente estructurada para empezar a practicar desde el día 1 sin perderte en el camino.',
  value: '$8.000'
}, {
  num: '02',
  title: 'Mapa Completo de los Chakras',
  subtitle: '',
  desc: 'El sistema de chakras explicado de forma práctica y visual. Cómo diagnosticar, equilibrar y trabajar cada chakra en tus sesiones reales.',
  value: '$10.000'
}, {
  num: '03',
  title: 'Manual Anti Dudas Reiki',
  subtitle: '',
  desc: 'Las preguntas que todo practicante se hace y nadie responde claramente. Tu guía de consulta rápida para cuando no sabés qué hacer.',
  value: '$9.000'
}, {
  num: '04',
  title: 'Protocolo Reiki de 10 Minutos',
  subtitle: '',
  desc: 'Sesiones cortas y efectivas para cuando el tiempo es limitado. Protocolos específicos de 10 minutos con resultados reales.',
  value: '$8.000'
}, {
  num: '05',
  title: 'Reiki de Bolsillo',
  subtitle: 'Afirmaciones y frases energéticas',
  desc: 'La guía compacta que siempre llevás con vos. Afirmaciones, frases y todo lo esencial del Reiki para consulta rápida en cualquier momento.',
  value: '$9.000'
}, {
  num: '06',
  title: 'Diario de Práctica y Progreso Reiki',
  subtitle: '',
  desc: 'Tu acompañamiento diario. Registro guiado de cada sesión para que veas tu evolución en tiempo real y mantengas la constancia.',
  value: '$9.000'
}];
export function BonusesSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#f3e9f7] py-12 md:py-16 px-5 sm:px-6 border-t border-[#e8d5f0] relative overflow-hidden" data-id="element-46">
      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-47">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-48">
          <h2 className="text-3xl md:text-5xl font-bold text-[#3d2a5f] mb-3" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-49">
            🎁 6 BONOS INCLUIDOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-50">
          {BONUSES.map((bonus, idx) => <div key={idx} className="bg-white border border-[#e8d5f0] rounded-xl p-5 flex flex-col h-full shadow-sm" data-id="element-51">
              <div className="flex items-center gap-3 mb-3" data-id="element-52">
                <span className="text-[#c9a14d] font-bold text-xl" data-id="element-53">
                  {bonus.num}
                </span>
                <div className="inline-flex bg-gradient-to-r from-[#c9a14d] to-[#b8945a] text-white text-[10px] font-bold px-2.5 py-1 rounded-full uppercase" data-id="element-54">
                  🎁 BONO {idx + 1}
                </div>
              </div>
              <h3 className="text-lg font-bold text-[#3d2a5f] mb-1 leading-tight" data-id="element-55">
                {bonus.title}
              </h3>
              {bonus.subtitle && <p className="text-[#c9a14d] text-xs font-semibold italic mb-2" data-id="element-56">
                  {bonus.subtitle}
                </p>}
              <p className="text-[#6b5a85] text-sm leading-relaxed mb-4 flex-grow mt-1" data-id="element-57">
                {bonus.desc}
              </p>
              <div className="flex items-center justify-between border-t border-[#e8d5f0] pt-3 mt-auto" data-id="element-58">
                <span className="text-[#6b5a85] text-xs line-through decoration-red-400/50" data-id="element-59">
                  {bonus.value}
                </span>
                <span className="text-[#c9a14d] font-bold text-sm uppercase tracking-wider" data-id="element-60">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-61">
          <p className="text-xl md:text-2xl text-[#3d2a5f] font-bold" data-id="element-62">
            Valor total bonos:{' '}
            <span className="text-[#6b5a85] line-through" data-id="element-63">$53.000</span>{' '}
            <span className="text-[#c9a14d]" data-id="element-64">→ GRATIS con tu MegaPack</span>
          </p>
        </div>
      </div>
    </section>;
}